// extracted by mini-css-extract-plugin
export default {"app-box":"_1nxrpl1","appBox":"_1nxrpl1","cta-button":"_1deb8a1","ctaButton":"_1deb8a1","app-box-resize-detector":"_1he1yd3","appBoxResizeDetector":"_1he1yd3","icon":"_1w8jrpv"};